import React from "react";
import { Card, Image, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdLocationOn, MdOutlineInfo } from "react-icons/md";
import illusMobility from "../../../assets/images/illusMobility.jpg";

const ComponentMobilityInfo = (props) => {
  const { t } = useTranslation();
  const { mobility, tabKeyMobility, setTabKeyMobility } = props;

  const scrollBloc = (ID) => {
    setTimeout(function () {
      document.getElementById(ID).scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <Card border={"black"} id={mobility._id} className="tablistDetailMobility">
      <Card.Header>
        <Nav
          variant="tabs"
          activeKey={tabKeyMobility}
          onSelect={(selectedKey) => {
            setTabKeyMobility(selectedKey);
            scrollBloc(mobility._id);
          }}
        >
          <Nav.Item>
            <Nav.Link eventKey="informations">
              <MdOutlineInfo />
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Card.Header>
      <Card.Body className="whiteSpace">
        <div style={{ flex: 1, fontSize: 12, marginLeft: 8 }}>
          <h4> {mobility.nom}</h4>
          {tabKeyMobility === "informations" && (
            <div className="d-flex flex-wrap justify-content-center">
              <Image
                className="roomSmall"
                src={
                  mobility.cardPic
                    ? process.env.REACT_APP_URL_EXPRESS +
                      "images/mobility/small/" +
                      mobility.cardPic
                    : illusMobility
                }
              />
              <span className="flex-grow-1 p-2">
                <p className="d-flex">
                  <MdLocationOn size="1.5em" className="me-1" />
                  <span>
                    {mobility.localisation.nom ? mobility.localisation.nom : "-"} <br />
                  </span>
                </p>
                <p className="d-flex">{mobility.procedure}</p>
              </span>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ComponentMobilityInfo;
